var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.owners_association && _vm.booking)?_c('booking-detail',{attrs:{"owners_association":_vm.owners_association,"booking":_vm.booking},on:{"doCancelBooking":_vm.doCancelBooking}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }